import { g as l } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconLoading",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], p = ["clip-path"], m = ["id"];
function _(e, i, d, g, h, t) {
  return n(), o("svg", {
    "aria-label": d.ariaLabel,
    class: s([t.iconSizeClass, "d-icon d-icon--loading"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Loading",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...i[0] || (i[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M6 1.5A4.5 4.5 0 1 0 10.5 6a.5.5 0 0 1 1 0A5.5 5.5 0 1 1 6 .5a.5.5 0 0 1 0 1Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, p),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...i[1] || (i[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, m)
    ])
  ], 10, f);
}
const S = /* @__PURE__ */ u(c, [["render", _]]);
export {
  S as default
};
//# sourceMappingURL=loading.js.map
